import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';

const getApiService = () => `${apiUtils.getBaseUri()}`;

const validateCardData = async data => {
    const uri = `${getApiService()}/forms/lost-or-stolen-card-form/steps/lost-or-stolen-card-step/validation`;
    const response = await HTTPClient().postJson(uri, data);
    if (!response.ok) {
        const resp = await response.json();
        throw `${resp.errors[0].message}`;
    }
    return true;
};

const validatePinCode = async data => {
    const uri = `${getApiService()}/forms/pinCodeForm/steps/pin-code-step/validation`;
    const response = await HTTPClient().postJson(uri, data);
    if (!response.ok) {
        const resp = await response.json();
        throw `${resp.errors[0].message}`;
    }
    return true;
};


const getLoyaltyPointBalance =  async (accountId) => {
    let uri ;
    if (accountId) {
        uri = `${apiUtils.getBaseUri()}/users/current/loyalty/points?accountId=${accountId}`;
    } else {
        uri = `${apiUtils.getBaseUri()}/users/current/loyalty/points`;
    }

    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to fetch loyalty Points (${response.status})`);
    }

    return await response.json();
}

const getSavedCardIframeURL = async () => {
    const uri = `${getApiService()}/users/current/paymentdetails/getPaymentInfosIframeURL`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        const resp = await response.json();
        throw `${resp.errors[0].message}`;
    } else {
        return await response.json();
    }
};

const getFormData = async () => {
    const uri = `${getApiService()}/forms/lost-or-stolen-card-form?fields=DEFAULT`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        const resp = await response.json();
        throw `${resp.errors[0].message}`;
    } else {
        return await response.json();
    }
};

const submitCardDetails = async data => {
    const uri = `${getApiService()}/users/current/loyalty/physical`;
    const response = await HTTPClient().postJson(uri, data);
    if (!response.ok) {
        const resp = await response.json();
        throw `${resp.errors[0].message}`;
    }
    return true;
};

const getSavedCards = async () => {
    const uri = `${getApiService()}/users/current/paymentdetails?saved=true`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        const resp = await response.json();
        throw `${resp.errors[0].message}`;
    }
    return await response.json();
};

export default {
    validateCardData,
    submitCardDetails,
    validatePinCode,
    getSavedCardIframeURL,
    getLoyaltyPointBalance,
    getSavedCards,
    getFormData,
};
